module.exports = __webpack_public_path__ + "img/paint-garden.60bbad1f.jpg";